import React from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PageTitle } from "../../components";
import { Plus, PlusCircle } from "@tiny/icons";
import { useLandingPage } from "./LandingPage.hooks";
import { useConfigView } from "../../Config.context";

function LandingPage({ imgUrl }: { imgUrl: string }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {
    anchorEl,
    handleCloseMenu,
    handleMenuOpen,
    open,
    onCreateCampaign,
    onCreateWorkflow,
  } = useLandingPage();

  const { config } = useConfigView();

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{
          p: 3,
          pb: 0,
          borderBottom: {
            xs: `1px solid ${theme.palette.grey[30]}`,
            md: "none",
          },
        }}
      >
        <PageTitle
          title={
            config?.appName === "tinyEmail" ? (
              <Typography variant="h1" m={0} color="grey.100" noWrap>
                Dashboard
              </Typography>
            ) : (
              <Typography variant="h2" m={0} color="grey.100" noWrap>
                Dashboard
              </Typography>
            )
          }
          hideRefresh
          actions={
            <>
              {!isMobile ? (
                <Button
                  color="primary"
                  variant="contained"
                  endIcon={<Plus />}
                  onClick={handleMenuOpen}
                >
                  Add New
                </Button>
              ) : (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={handleMenuOpen}
                >
                  <PlusCircle />
                </IconButton>
              )}
              <Menu
                id="creation-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{ style: { marginTop: 8 } }}
              >
                <MenuItem
                  onClick={() => {
                    onCreateCampaign();
                    handleCloseMenu();
                  }}
                >
                  <Typography variant="p2">Campaign</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    onCreateWorkflow();
                    handleCloseMenu();
                  }}
                >
                  <Typography variant="p2">Workflow</Typography>
                </MenuItem>
              </Menu>
            </>
          }
        />
      </Box>

      <Box
        sx={{
          mt: 4,
          height: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 3,
          pb: isMobile ? 4 : 0,
        }}
      >
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              color="grey.100"
              variant="h1"
              fontWeight="bold"
              mb={4}
              sx={{
                fontSize: { xs: "1.75rem", sm: "2rem", md: "2.5rem" },
                lineHeight: 1.2,
                textAlign: { sm: "center", md: "left" },
              }}
            >
              Kickstart Your Journey:
              <br />
              Build Campaigns or Workflows
            </Typography>

            <Typography
              color="grey.80"
              variant="h4R"
              mb={isMobile ? 6 : 8}
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                lineHeight: 1.6,
                textAlign: { sm: "center", md: "left" },
              }}
            >
              Launch email campaigns and email automations in minutes.
            </Typography>

            <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Button
                color="primary"
                variant="contained"
                endIcon={<Plus />}
                onClick={handleMenuOpen}
                sx={{
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                Add New
              </Button>
            </Box>
          </Grid>

          {!isMobile && (
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <Box
                component="img"
                src={imgUrl}
                alt="Workflow illustration"
                sx={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default LandingPage;
